// extracted by mini-css-extract-plugin
export var wrapper = "BurgerBtn-module--wrapper--56701";
export var fixed = "BurgerBtn-module--fixed--a5bd3";
export var button = "BurgerBtn-module--button--0037d";
export var active = "BurgerBtn-module--active--a6c5c";